// removed by extract-text-webpack-plugin
module.exports = {"sidebarMenu":"_2_zIZYnzvKIS9Nb5H1Wpv2","menuFooter":"_1F3gmXCKB0bMpaD2TuO5Et","activeLink":"_35AJ43QwSklv3EAZqalShk","subMenu":"_1RxMnZ-Ou9_DDk7aUr1HcC","red":"_2igxBdMy3ytLu1tDLyijLv"};


//////////////////
// WEBPACK FOOTER
// ./client/src/styles/PatientSidebarMenu.scss
// module id = 474
// module chunks = 0